<script>
export default {
  computed: {
    labelClass(){
      const labelValue = {
        'noW100': '$style.label',
        'default': '$style.label'
      }
      if(labelValue[this.spButtonType]){
        return labelValue[this.spButtonType]
      }else{
        return labelValue['default']
      }
    }
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    direction: {
      type: String,
      default: 'horizontal',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // icon 顏色設定
    spColorType: {
      type: String
    },
    // button 長度區別
    spButtonType:{
      type: String,
      default: ''
    }
  },
}
</script>

<template>
  <div :class="spButtonType === 'productListItem' ? $style.spFlex : ''">
    <template v-if="spButtonType === 'productListItem'">
      <button :class="[$style.button]" v-on="$listeners">
        <BaseIcon v-if="loading" :class="$style.icon"  name="spinner" spin />
        <BaseIcon v-else-if="icon" :class="[$style[`icon--color-${spColorType}`]]" :name="icon" />
        <div :class="$style.flexLabel">
          <slot></slot>
        </div>
      </button>
    </template>

    <template v-else>
      <button :class="[$style.button, $style[`button--${direction}`]]" v-on="$listeners">
        <BaseIcon v-if="loading" :class="$style.icon"  name="spinner" spin />
        <BaseIcon v-else-if="icon" :class="[$style.icon, $style[`icon--color-${spColorType}`]]" :name="icon" />
        <div v-if="spButtonType === ''" :class="$style.label">
          <slot></slot>
        </div>
      </button>
    </template>
  </div>
</template>

<style lang="scss" module>
.label {
  flex: 1;
  padding-top: $size-button-padding-vertical;
}
.icon {
  flex-basis: 3rem;
  // &--color-primary{
  //   color: blue
  // }
  &--color-primary {
    color: $color-primary;
    margin-right: 6px;

  }
}
.spFlex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flexLabel {
  width: 100%;
  font-size: 12px;
  color: $color-secondary;
}

/* Stacked Buttons */
.button {
  -webkit-appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  background-color: transparent;
  border: none;
  transition: $all-transition;
  &:hover:not(:disabled) {
    color: $color-primary;
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }

  &--horizontal {
    width: 100%;
    .label {
      padding-bottom: $size-button-padding-vertical;
    }
    &:not(:last-child) .label {
      // border-bottom: 1px solid $color-border-base;
    }
    .icon {
      margin-top: $size-button-padding-vertical;
      margin-bottom: $size-button-padding-vertical;
    }
  }
  &--vertical {
    flex-direction: column;
    padding: $size-button-padding-vertical;
    border: 1px solid $color-border-base;
    &:hover:not(:disabled) {
      color: white;
      background: $color-primary-gradient;
      border-color: $color-primary;
    }
    .icon {
      font-size: 2.5em;
    }
  }
}
</style>
